import DataTile from "../../metrics/DataTile";
import { fetchUsers} from "../../../../actions";
import React, {useEffect} from "react";
import {bbDangerousStringToDate} from "../../../../util/bbHelpers";
import {useDispatch, useSelector} from "react-redux";
import PersonAddIcon from "@material-ui/icons/PersonAdd";


const Tile = (props) => {

    //select users object from state
    const { users, loadingUsers } = useSelector(({users})=> users);
    const dispatch = useDispatch();

    //api call gets users object from state-- users is an object that contains user data objects as key/value pairs
    useEffect(()=>{
        if(!users && !loadingUsers){
            dispatch(fetchUsers())
        }
    }, [users, dispatch])

    //function compares two dates and return the number of days different
    const calcDiffDays = (object, dateKey) => {
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

        const firstDate = bbDangerousStringToDate(object[dateKey], false)

        const secondDate = new Date();

        return Math.round(Math.abs((firstDate - secondDate) / oneDay));
    }

    const usersArray = users && Object.values(users);

    //newUsers is equal to the array created by "flattening" the users object into an array containing the user objects and then filtering
    //the array into users created in the last 7 days
    const newUsers = users
        && Array.isArray(usersArray)
        && usersArray
            .filter(user=> calcDiffDays(user, "date_joined") < 30);

    //find Data Tile component @/components/customBreachBits/metrics--this tile injects data rather than data tile componetn calling state itself
    return (
        <DataTile
            color="primary"
            subTitle="New Users Last 30 Days"
            // tipText={"New Users are users added in the last 30 days."}
            icon={<PersonAddIcon style={{fontSize: "70px"}}/>}
            valueFunction={(stateData) => stateData ? newUsers.length : null}
        />
    )
}

export default Tile;